import { render } from "./CompanyNotFoundView.vue?vue&type=template&id=123fd7ce&scoped=true&ts=true"
import script from "./CompanyNotFoundView.vue?vue&type=script&lang=ts"
export * from "./CompanyNotFoundView.vue?vue&type=script&lang=ts"

import "./CompanyNotFoundView.vue?vue&type=style&index=0&id=123fd7ce&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123fd7ce"]])

export default __exports__